import { RouteObject } from 'react-router-dom'
import NotificationsPage from '@/pages/notifications/NotificationsPage.tsx'

const NOTIFICATION_ROUTES: RouteObject[] = [
  {
    path: 'notifications',
    element: <NotificationsPage />
  }
]

export default NOTIFICATION_ROUTES
